import { css } from "styled-components";
const Flex = css`
  display: flex;
`;
css`
  display: flex;
  flex-direction: column;
`;
const FlexCenter = css`
  display: flex;
  align-items: center;
`;
const FlexJustifyCenter = css`
  ${FlexCenter};
  justify-content: center;
`;
export {
  Flex,
  FlexCenter,
  FlexJustifyCenter
};
